import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
import 'react-datetime/css/react-datetime.css';
import RepeatEveryMonths from './RepeatEveryMonths';
import RepeatEveryYears from './RepeatEveryYears';
import RepeatEndsOn from './RepeatEndsOn';
import {RecursiveWeeks} from '../ReminderFunction';
import {allowOnlyNumbersKeyDown} from '../../../../../../../Utils/CommonFunctions';
class RepeatEveryWithOption extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
    }
  }
 
  render() {
    const  {
    reminderJson,
    actionChangeHandler
    } = this.props;
    const repeatFrequencyArr =[0,1,2,3];
    const repeatFrequencyObjArr =['Day','Week','Month','Year'];
    
    console.log(reminderJson);
    return (
     <Wrp>
        <div className="form-group">
            <div className="input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text">Repeat Every </span>
                </div>
                <input 
                    type="number" 
                    name="" 
                    min={1}
                    value={reminderJson.repeat_every}
                    onKeyDown={allowOnlyNumbersKeyDown}
                    onChange={e=>{
                        const val = e.target.value;
                        if (val.length > 4) return;
                        if (val !== '' && Number(val) < 1) return;
                        actionChangeHandler(e,'repeat_every',val);
                    }} className="form-control" />
                <select 
                    className="form-control" 
                    onChange={e=>actionChangeHandler(e,'repeat_frequency',e.target.value)} 
                    value={reminderJson.repeat_frequency}>
                    {repeatFrequencyArr.map((item,itemIndex)=>{
                        const displayFreq = (Number(reminderJson.repeat_every)===1)?repeatFrequencyObjArr[itemIndex]:repeatFrequencyObjArr[itemIndex]+'s'
                        return(
                            <option 
                                key={itemIndex} 
                                value={item}> 
                                {displayFreq} 
                            </option>
                        )
                    })}
                </select>
            </div>	
        </div>
        {(Number(reminderJson.repeat_frequency)===2 || Number(reminderJson.repeat_frequency)===3)?
            <div className="form-group mb-2">
                <label className="form-radio-label">
                    <input 
                        className="form-radio-input" 
                        type="radio" name="optionsRadios" 
                        onChange={e=>this.repeatOptionChangeHandler(e,'DAY')}
                        checked={(reminderJson.repeatOption==='DAY')?true:false} />
                    <span className="form-radio-sign ml-1">
                        {`By Day`}
                    </span>
                </label>
                <label className="form-radio-label ml-3">
                    <input 
                        className="form-radio-input" 
                        type="radio" 
                        name="optionsRadios" 
                        onChange={e=>this.repeatOptionChangeHandler(e,'WEEK')}
                        checked={(reminderJson.repeatOption==='WEEK')?true:false} />
                    <span className="form-radio-sign ml-1">
                        {`By Week`} 
                    </span>
                </label>
		    </div>
        :''}
        
        {/* Weeks */}
        {(Number(reminderJson.repeat_frequency)===1)?
            <RepeatEveryWeeks 
                {...this.props}
                weeksOnSelectHandler={this.weeksOnSelectHandler} />
        :(Number(reminderJson.repeat_frequency)===2)?
            <RepeatEveryMonths
                {...this.props} />       
        :(Number(reminderJson.repeat_frequency)===3)?
            <RepeatEveryYears 
            {...this.props}/>       
        :''}
        <RepeatEndsOn {...this.props} />
     </Wrp>       
    );
  }
  repeatOptionChangeHandler = (e,option)=>{
    const {reminderJson,updateReminderComponentObject} = this.props;
    reminderJson.repeatOption = option;
    reminderJson.repeat_dom = '';
    updateReminderComponentObject(reminderJson);
    
  }
//WEEKS ON SELECT ACTIONS
  weeksOnSelectHandler = (wthis,week,boll)=>{
    const {reminderJson,actionChangeHandler} = this.props;
    let repeatWeekday = null;
    if(boll===true){
        repeatWeekday = reminderJson.repeat_weekday+Number(week);
    }else{
        repeatWeekday = reminderJson.repeat_weekday-Number(week);
    }
    console.log(repeatWeekday);
    actionChangeHandler(wthis,'repeat_weekday',repeatWeekday)
  }
}



const RepeatEveryWeeks =(props)=>{
    const {weeksOnSelectHandler,reminderJson} = props;
    const repeatWeekday = reminderJson.repeat_weekday;
    const weeks = ['S','M','T','W','T','F','S'];
    const weeksInBytes = [1,2,4,8,16,32,64];
    let selectedWeeks = [];
      selectedWeeks = (repeatWeekday!==null && repeatWeekday!==0)?RecursiveWeeks(weeksInBytes,selectedWeeks,repeatWeekday):[];
    //   console.log(selectedWeeks);
    return(
        <div className="form-group">
        <label className="d-block"> {`Repeat On`} </label>
            <div className="selectgroup selectgroup-secondary selectgroup-pills">
                {(weeks.map((item,itemIndex)=>{
                    const isSelected = (selectedWeeks.indexOf(weeksInBytes[itemIndex])!==-1)?true:false;
                    return(
                        <label className="selectgroup-item" key={itemIndex}>
                            <input 
                                type="checkbox" 
                                name="icon-input" 
                                value={weeksInBytes[itemIndex]} 
                                className="selectgroup-input" 
                                checked={isSelected} 
                                onChange={e=>weeksOnSelectHandler(e,weeksInBytes[itemIndex],!isSelected)} />
                            <span className="selectgroup-button selectgroup-button-icon"> {item} </span>
                        </label>
                    )
                }))}
            </div>
         
    </div>

    )

}

export default RepeatEveryWithOption;
